<template>
  <div id="app">
        <Header v-if="['login', 'register', 'forgotpassword', 'marketsmithindia','psiverify'].indexOf($route.name) == -1"></Header>
        <router-view/>
      <Footer v-if="['login', 'register', 'forgotpassword', 'marketsmithindia','psiverify'].indexOf($route.name) == -1"></Footer>
	  <notifications group="allAlerts" position="top center"  />
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/newfooter";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    
  },

  data() {
    return {

    };
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue